import {
  Container,
  Box,
  Grid,
  CircularProgress,
  Alert,
  AlertTitle,
  Divider,
} from "@mui/material";
import { useRepairItems } from "hooks/useRepairItems";
import RepairItemWidget from "./RepairItemWidget";
import RestarterImpactItems from "./RestarterImpactItems";
import { useMemo } from "react";
import useRestarterEventLogin from "hooks/restarter/useRestarterEventLogin";
import RestarterEventLoginModal from "components/restarter/RestarterEventLoginModal";
import RestarterPageHeader from "components/restarter/RestarterPageHeader";

const RestarterDashboardPage = () => {
  const { handleLogout, loginEventCode, loginFormOpen, handleLoginToEvent } =
    useRestarterEventLogin();
  const { loading, error, repairItems } = useRepairItems({
    loginEventCode,
  });

  const sortedItems = useMemo(
    () =>
      repairItems.sort((a, b) => {
        if (!a.date) return 1;
        if (!b.date) return -1;
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      }),
    [repairItems]
  );

  return (
    <Container maxWidth="lg" sx={{ my: 4 }}>
      <Box visibility={loginFormOpen ? "hidden" : "visible"}>
        <RestarterPageHeader
          title="Today's Impact"
          loginEventCode={loginEventCode}
          onLogout={handleLogout}
        />

        {loading && <CircularProgress />}
        {error && (
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            There was an error fetching the repair items. Please try again
            later.
          </Alert>
        )}
        {!loading && !error && (
          <>
            <RestarterImpactItems repairItems={repairItems} />
            <Divider variant="middle" sx={{ my: 5 }}>
              List of Items
            </Divider>
            <Grid container spacing={3}>
              {sortedItems.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <RepairItemWidget item={item} />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Box>
      <RestarterEventLoginModal
        formLabel="Go to Event Dashboard"
        isOpen={loginFormOpen}
        onLoginValidation={handleLoginToEvent}
      />
    </Container>
  );
};

export default RestarterDashboardPage;
